import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import './LegalPages.css';

const KullanimKosullari = () => {
  return (
    <Container maxWidth="md" className="legal-container">
      <Paper elevation={3} className="legal-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Kullanım Koşulları
        </Typography>

        <div className="section">
          <Typography variant="h6" className="section-title">
            1. Hizmet Kullanımı
          </Typography>
          <Typography variant="body1" paragraph>
            HOPS platformunu kullanarak, bu kullanım koşullarını kabul etmiş sayılırsınız. 
            Platform üzerinden sunulan hizmetleri, yürürlükteki yasalara ve bu koşullara uygun şekilde kullanmayı taahhüt edersiniz.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            2. Hesap Güvenliği
          </Typography>
          <Typography variant="body1" paragraph>
            Hesabınızın güvenliğinden siz sorumlusunuz. Hesap bilgilerinizi güvende tutmalı ve 
            yetkisiz erişime karşı korumalısınız. Şüpheli bir durum fark ettiğinizde derhal bizimle iletişime geçmelisiniz.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            3. Ödeme ve Kontör Kullanımı
          </Typography>
          <Typography variant="body1" paragraph>
            Satın alınan kontörler, aktivasyon tarihinden itibaren süresiz olarak geçerlidir. 
            Kontör ücretleri iade edilemez. Kontör kullanımı, platform üzerinden gerçekleştirilen işlemler için geçerlidir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            4. Fikri Mülkiyet
          </Typography>
          <Typography variant="body1" paragraph>
            Platform üzerindeki tüm içerik, tasarım ve yazılım HOPS'un fikri mülkiyetidir. 
            Bu içeriklerin izinsiz kullanımı, kopyalanması veya dağıtılması yasaktır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            5. Sorumluluk Sınırları
          </Typography>
          <Typography variant="body1" paragraph>
            HOPS, platformun kesintisiz ve hatasız çalışacağını garanti etmez. 
            Platform kullanımından doğabilecek dolaylı veya dolaysız zararlardan sorumlu tutulamaz.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            6. Değişiklikler
          </Typography>
          <Typography variant="body1" paragraph>
            HOPS, bu kullanım koşullarını önceden haber vermeksizin değiştirme hakkını saklı tutar. 
            Değişiklikler, platformda yayınlandığı tarihten itibaren geçerli olur.
          </Typography>
        </div>

        <div className="contact-info">
          <Typography variant="h6" gutterBottom>
            İletişim Bilgileri
          </Typography>
          <Typography variant="body1">
            Kullanım koşulları hakkında sorularınız için:
          </Typography>
          <Typography variant="body1">
            E-posta: info@hopssoftware.com
          </Typography>
          <Typography variant="body1">
            Telefon: +90 552 464 11 16
          </Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default KullanimKosullari; 